import { Outlet } from 'react-router-dom'

import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import usePrivateRoutesRedirect from '~/hooks/usePrivateRoutesRedirect'
import ContentWrapper from '~/layouts/account/contentWrapper'
import { ECognitoGroups } from '~/models/auth'

type TProps = {
  allowedGroups: ECognitoGroups[]
}

function PartnerRestrictedLayout({ allowedGroups = [] }: TProps) {
  const allowedGroupsIncludingAdmin = [
    ECognitoGroups.admin,
    ...(allowedGroups || []),
  ]
  const isAuthCheckComplete = usePrivateRoutesRedirect({
    requiredUserGroups: allowedGroupsIncludingAdmin,
  })

  if (!isAuthCheckComplete) {
    return <LoadingWithBackdrop show />
  }

  return (
    <PartnerThemeWrapper>
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
    </PartnerThemeWrapper>
  )
}

export default PartnerRestrictedLayout
